import AccordionContent from "../../elements/accordion/AccordionContent";

const Faqs = ({ accordionData }) => {
  return (
    <section className="accordion-section">
      <h3 className="titles">
        RESPUESTAS ESPECíFICAS A LAS <br />
        <span>DUDAS MáS COMUNES.</span>
      </h3>
      <div className="accordion">
        {accordionData.map(({ title, content, id }) => (
          <AccordionContent key={id} title={title} content={content} />
        ))}
      </div>
    </section>
  );
};

export default Faqs;
